import { h } from "preact";
import { useSelector, useDispatch } from "react-redux";

import { setRelocationCasesFilter } from "../store/uiSlice";
import Filter from "./Filter.jsx";

const OPTIONS = [
  { value: "", text: "All cases" },
  { value: "ongoing", text: "Ongoing cases" },
  { value: "completed", text: "Completed cases" },
];

export default function RelocationCasesFitler() {
  const dispatch = useDispatch();
  const selected = useSelector((state) => state.ui.relocationCasesFitler);

  function handleChange(value) {
    dispatch(setRelocationCasesFilter(value));
  }

  return (
    <Filter
      icon="check_circle"
      onChange={handleChange}
      options={OPTIONS}
      selected={selected}
    />
  );
}
